import { useLayoutEffect, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router"

import Loading from "consumer/setup/loading";

import listStype from "./list.module.css"
import { convert_time } from "consumer/@@@/convert_time"
import { convert_grade } from "consumer/@@@/convert_grade"
import { get_grade_list } from "consumer/@@@/get_grade_list"
import { get_apply_list } from "../@@@/get_apply_list";
import Button from "consumer/custom/button";


export default function List() {

    const location = useLocation()
    const student_name = location.state['student_name']
    const parent_phone = location.state['parent_phone']

    const navigate = useNavigate()

    const isMounted = useRef(0)

    const [applyList, Set_applyList] = useState([])
    const [gradeList, Set_gradeList] = useState([])

    const [loading, Set_loading] = useState(true)

    useLayoutEffect(() => {
        if(isMounted.current === 0) {
            get_apply_list({
                student_name: student_name,
                parent_phone: parent_phone,
                Set_applyList: Set_applyList
            })
            get_grade_list({
                Set_gradeList: Set_gradeList,
                isMounted: isMounted
            })
        }
    }, [])

    useLayoutEffect(() => {
        if(isMounted.current === 1) {
            Set_loading(false)
        }
    }, [gradeList])

    return(
        <>
            <Loading
                loading={loading}
            ></Loading>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    paddingInline: "10px",
                    boxSizing: "border-box",
                    marginTop: "20px"
                }}
            >
                {applyList
                .map((value, index) => {
                    return(
                        <div
                            key={index}
                            className={
                                listStype['list']
                                + ' ' +
                                (value['status'] === 0 && listStype['cancel'])
                            }
                        >
                            <div
                                style={{
                                    marginBottom: "5px"
                                }}
                            >
                                <div className={listStype['label']}>행사 정보</div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap"
                                    }}
                                >
                                    <div>{value['Schedule']['Event']['name']}</div>
                                    <div style={{marginInline: "5px"}}>/</div>
                                    <div>{value['Schedule']['branchName']}</div>
                                    <div style={{marginInline: "5px"}}>/</div>
                                    <div>{value['Schedule']['targetDate']} {convert_time(value['Schedule']['targetTime'])}</div>
                                    <div style={{marginInline: "5px"}}>/</div>
                                    <div>
                                        {function() {
                                            if(value['Schedule']['payment'] === 0) {
                                                return '무료'
                                            }
                                            else {
                                                return `${value['Schedule']['payment']}원`
                                            }
                                        }()}
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className={listStype['label']}>신청 정보</div>
                                {/* <div>
                                    {function() {
                                        const w = new Date(value['submittedAt'].toString())
                                        const day = w.toLocaleString("ko-KR", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit"
                                        }).replaceAll(". ", "-").replace(".", "")
                                        const time = w.toLocaleString("ko-KR", {
                                            hour: "2-digit",
                                            minute: "2-digit"
                                        }).replace(":", "시 ") + "분"
                                        return `${day} ${time}`
                                    }()}
                                </div> */}

                                <div
                                    style={{
                                        display: "flex"
                                    }}
                                >
                                    <div>{value['studentName']}</div>
                                    <div style={{marginInline: "5px"}}>/</div>
                                    <div>{value['studentGender']}</div>
                                    <div style={{marginInline: "5px"}}>/</div>
                                    <div>
                                        {convert_grade({
                                            grade_list: gradeList,
                                            grade: value['studentGrade']
                                        })}
                                    </div>
                                    <div style={{marginInline: "5px"}}>/</div>
                                    <div>
                                        {function() {
                                            if(value['isEnrolled']) {
                                                return '재원생'
                                            }
                                            else {
                                                return '비재원생'
                                            }
                                        }()}
                                    </div>
                                </div>
                            </div>

                            {value['status'] === 1 && value['paid'] === 0 &&
                            <>
                                <div
                                    style={{
                                        fontSize: "15px",
                                        color: "red",
                                        marginTop: "5px",
                                        marginBottom: "10px"
                                    }}
                                >
                                    <span>{function() {
                                        const create_day = value['createdAt']
                                        const expire_day = new Date(create_day)
                                        expire_day.setHours(expire_day.getHours() + 1)

                                        return expire_day.toLocaleString('ko-KR')
                                    }()}</span>
                                    <span>까지 결제를 완료하지 않으면 신청이 취소됩니다.</span>
                                </div>

                                <Button
                                    text="결제하러 가기"
                                    style={{
                                    }}
                                    event={{
                                        onClick: function() {
                                            navigate(`/step4`, {
                                                state: {
                                                    consumer_id: value['id']
                                                },
                                                replace: true
                                            })
                                        }
                                    }}
                                ></Button>
                            </>
                            }
                        </div>
                    )
                })}
            </div>
        </>
    )
}